import React, { Component } from 'react';
import PropTypes from 'prop-types';

function wiv(params) {
  params = params || {};
  var isMobile = false;

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  }

  var mobileCompressionFactor = validatePositiveInteger(params.mobileCompressionFactor, 2);
  var globalCompressionFactor = validatePositiveInteger(params.globalCompressionFactor);

  if (isMobile) {
    globalCompressionFactor *= mobileCompressionFactor;
  }

  var cache = {};
  var wivCounter = 0;
  var speeds = {
    "slow": .15,
    "standard": .55,
    "fast": 1.55,
    "faster": 3.15,
    "turbo": 6.15
  };

  function initWiv(wiv) {
    //style wiv elements
    wiv.style.display = "inline-block";
    wiv.style.borderRadius = parseFloat(wiv.dataset.wivHeight) + "px";
    wiv.children[0].style.padding = parseFloat(wiv.dataset.wivHeight) * 4 + "px"; //insert wiv canvas element

    var canvas = document.createElement('canvas');
    canvas.id = "wiv-curves-" + wivCounter++;
    canvas.className = "wiv-curves";
    canvas.width = wiv.offsetWidth;
    canvas.height = wiv.offsetHeight;
    canvas.style.zIndex = 16;
    canvas.style.position = "absolute";
    canvas.style.pointerEvents = "none";
    wiv.insertBefore(canvas, wiv.firstChild);
    var color = wiv.dataset.wivColor !== undefined ? wiv.dataset.wivColor : "#FF0000";
    var speed = speeds[wiv.dataset.wivSpeed] || parseFloat(wiv.dataset.wivSpeed) || speeds.standard;
    var height = parseFloat(wiv.dataset.wivHeight);
    var tightness = parseFloat(wiv.dataset.wivTightness);
    var thickness = parseFloat(wiv.dataset.wivThickness);
    var increment = validatePositiveInteger(wiv.dataset.wivCompressionFactor);
    increment *= globalCompressionFactor;
    var ctx = canvas.getContext("2d");
    ctx.strokeStyle = color;
    ctx.lineWidth = thickness;
    cache[canvas.id] = {
      'speed': speed,
      'height': height,
      'tightness': tightness,
      'thickness': thickness,
      'increment': increment,
      'color': color,
      'context': ctx,
      'count': 0
    };
  }
  /**
   * Initialize all wiv elements. Going in reverse makes sure heights adjust to children wivs.
   */


  function initWivs() {
    var wivs = document.getElementsByClassName("wiv");

    for (i = wivs.length - 1; i >= 0; i--) {
      initWiv(wivs[i]);
    } // reset the previous' wiv canvas size for responsive views


    for (i = 0; i < wivs.length; i++) {
      var canvas = document.getElementsByTagName("canvas")[i];
      canvas.height = wivs[i].offsetHeight;
      canvas.width = wivs[i].offsetWidth;
    }

    window.requestAnimationFrame(processWivs);
  }

  function processWivs() {
    var wivCurves = document.getElementsByClassName("wiv-curves");
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = wivCurves[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var wivCurve = _step.value;
        var curveCache = cache[wivCurve.id];
        var speed = curveCache.speed;
        var height = curveCache.height;
        var tightness = curveCache.tightness;
        var thickness = curveCache.thickness;
        var increment = curveCache.increment;
        var count = curveCache.count;
        var color = curveCache.color;
        var ctx = curveCache.context;
        curveCache.count = drawLines(wivCurve, speed, height, tightness, thickness, increment, count, color, ctx);
      } // reanimate

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    window.requestAnimationFrame(processWivs);
  }
  /**
  Represents the logic to draw a single frame. Animates all wivs
  */


  function drawLines(canvas, speed, height, tightness, thickness, increment, frame, color) {
    var ctx = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

    if (ctx === null) {
      ctx = canvas.getContext("2d");
    }

    ctx.beginPath();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var x = height * 2 + thickness;
    var y = height - Math.sin((x - frame) * tightness * Math.PI / 180) * height + thickness; //draw top

    for (x = height * 3; x <= canvas.width - height * 3; x += increment) {
      y = height - Math.sin((x - frame) * tightness * Math.PI / 180) * height + thickness;
      ctx.lineTo(x, y);
    } //draw right


    for (; y <= canvas.height - height * 3; y += increment) {
      x = canvas.width - height * 3 + height - Math.cos((y - frame) * tightness * Math.PI / 180) * height + thickness;
      ctx.lineTo(x, y);
    } //draw bottom


    for (; x >= height * 3; x -= increment) {
      y = canvas.height - height * 3 + height - Math.sin((x - frame) * tightness * Math.PI / 180) * height + thickness;
      ctx.lineTo(x, y);
    } //draw left


    for (; y >= height * 2 + thickness; y -= increment) {
      x = height - Math.cos((y - frame) * tightness * Math.PI / 180) * height + thickness;
      ctx.lineTo(x, y);
    } //draw top


    for (; x <= height * 3 + increment; x += increment) {
      y = height - Math.sin((x - frame) * tightness * Math.PI / 180) * height + thickness;
      ctx.lineTo(x, y);
    } //pull color from dataset


    ctx.strokeStyle = color;
    ctx.lineWidth = thickness;
    ctx.stroke(); //current frame is tracked on per wiv basis. This is to help with speed calculations

    if (frame > 100000) {
      frame = 0;
    }

    frame = (frame ? frame : 0) + speed;
    return frame;
  }

  function validatePositiveInteger(value, defaultVal) {
    defaultVal = defaultVal || 1;
    value = parseInt(value);

    if (!value || value < 1) {
      value = defaultVal;
    }

    return value;
  }

  return {
    initWivs: initWivs,
    drawLines: drawLines
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var wiv$1 = wiv();
var speeds = {
  'slow': 0.15,
  'standard': 0.55,
  'fast': 1.55,
  'faster': 3.15,
  'turbo': 6.15
};

var Wiv = function (_Component) {
  inherits(Wiv, _Component);

  function Wiv() {
    classCallCheck(this, Wiv);

    var _this = possibleConstructorReturn(this, (Wiv.__proto__ || Object.getPrototypeOf(Wiv)).call(this));

    _this.state = {
      height: 0,
      width: 0
    };

    _this.animateLines = function () {
      var _this$props = _this.props,
          speed = _this$props.speed,
          height = _this$props.height,
          tightness = _this$props.tightness,
          thickness = _this$props.thickness,
          color = _this$props.color;
      var ctx = _this.ctx,
          count = _this.count;
      var canvas = _this.canvas.current;
      speed = typeof speed === 'string' ? speeds[speed] : speed;
      _this.count = wiv$1.drawLines(canvas, speed, height, tightness, thickness,
      /* increment */
      1, count, color, ctx);
      window.requestAnimationFrame(_this.animateLines);
    };

    _this.canvas = React.createRef();
    _this.wiv = React.createRef();
    return _this;
  }

  createClass(Wiv, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _wiv$current = this.wiv.current,
          offsetHeight = _wiv$current.offsetHeight,
          offsetWidth = _wiv$current.offsetWidth;
      this.setState({
        height: offsetHeight,
        width: offsetWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.ctx && this.canvas.current) {
        var ctx = this.canvas.current.getContext('2d');
        ctx.strokeStyle = this.props.color;
        ctx.lineWidth = this.props.thickness;
        this.ctx = ctx;
        this.count = 0;
        window.requestAnimationFrame(this.animateLines);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          children = _props.children,
          className = _props.className,
          style = _props.style;

      var outerDivStyle = _extends({
        display: 'inline-block',
        borderRadius: height
      }, style);

      var canvasStyle = {
        zIndex: 16,
        position: 'absolute',
        pointerEvents: 'none'
      };
      return React.createElement('div', {
        style: outerDivStyle,
        className: className
      }, React.createElement('canvas', _extends({}, this.state, {
        style: canvasStyle,
        ref: this.canvas
      })), React.createElement('div', {
        style: {
          padding: height * 4
        },
        ref: this.wiv
      }, children));
    }
  }]);
  return Wiv;
}(Component);

Wiv.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
  height: PropTypes.number,
  color: PropTypes.string,
  speed: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(Object.keys(speeds))]),
  tightness: PropTypes.number,
  thickness: PropTypes.number
};
Wiv.defaultProps = {
  color: '#FF0000',
  speed: 'standard',
  height: 5,
  tightness: 6,
  thickness: 2
};
export default Wiv;